"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.00098C2.73478 2.00098 2.48043 2.10633 2.29289 2.29387C2.10536 2.48141 2 2.73576 2 3.00098V10.001H7C7.26522 10.001 7.51957 10.1063 7.70711 10.2939C7.89464 10.4814 8 10.7358 8 11.001V11.101C8 12.151 8.85 13.001 9.9 13.001H10.1C10.6039 13.001 11.0872 12.8008 11.4435 12.4445C11.7998 12.0882 12 11.6049 12 11.101V11.001C12 10.7358 12.1054 10.4814 12.2929 10.2939C12.4804 10.1063 12.7348 10.001 13 10.001H18V3.00098C18 2.73576 17.8946 2.48141 17.7071 2.29387C17.5196 2.10633 17.2652 2.00098 17 2.00098H3ZM18 12.001H13.896C13.693 12.8552 13.2079 13.616 12.5191 14.1604C11.8303 14.7047 10.978 15.0009 10.1 15.001H9.9C9.02202 15.0009 8.16972 14.7047 7.48089 14.1604C6.79206 13.616 6.30696 12.8552 6.104 12.001H2V17.001C2 17.2662 2.10536 17.5205 2.29289 17.7081C2.48043 17.8956 2.73478 18.001 3 18.001H17C17.2652 18.001 17.5196 17.8956 17.7071 17.7081C17.8946 17.5205 18 17.2662 18 17.001V12.001ZM0 3.00098C0 2.20533 0.316071 1.44227 0.87868 0.879656C1.44129 0.317047 2.20435 0.000976563 3 0.000976562H17C17.7956 0.000976563 18.5587 0.317047 19.1213 0.879656C19.6839 1.44227 20 2.20533 20 3.00098V17.001C20 17.7966 19.6839 18.5597 19.1213 19.1223C18.5587 19.6849 17.7956 20.001 17 20.001H3C2.20435 20.001 1.44129 19.6849 0.87868 19.1223C0.316071 18.5597 0 17.7966 0 17.001V3.00098Z",
    fill: fill
  }));
};

exports["default"] = _default;